var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mapName"},[_c('v-row',[_c('v-subheader',{staticStyle:{"margin":"-10px","padding-left":"23px","font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.basemap)+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }